import type { QueryStatus, MutationStatus } from '@tanstack/react-query';

import { Alert, AlertAction, Text } from '@simplywallst/ui-core';

import { AlertWrapper } from './styled';

type Hook =
  | 'useCreateNoteReminder'
  | 'useNote'
  | 'useUpdateNoteReminder'
  | 'useDeleteNoteReminder';
type StatusMap = {
  [key in Hook]: {
    action: string;
    reset: () => void;
    status: QueryStatus | MutationStatus;
  };
};

export interface NoteReminderAlertProps {
  hooks: Hook[];
  statusMap: StatusMap;
  type: 'error' | 'success';
}

const NoteReminderAlert = ({
  hooks,
  statusMap,
  type,
}: NoteReminderAlertProps) => {
  const hook = Object.keys(statusMap)
    .filter((key) => hooks.includes(key as Hook))
    .reduce<string | undefined>(
      (accumulator, key) =>
        statusMap[key].status === type ? key : accumulator,
      undefined
    );

  if (typeof hook !== 'undefined') {
    const styleType = type === 'error' ? 'negative' : 'positive';
    const message =
      type === 'error'
        ? `There was a problem trying to ${statusMap[hook].action} this note reminder`
        : `Reminder ${statusMap[hook].action}d`;
    const handleOnClick = statusMap[hook].reset;

    return (
      <AlertWrapper>
        <Alert
          actions={
            <AlertAction
              data-cy-id={`note-reminder-${type}-alert`}
              onClick={handleOnClick}
            >
              OK
            </AlertAction>
          }
          styleType={styleType}
        >
          <Text typography="xSmall" color="white">
            {message}
          </Text>
        </Alert>
      </AlertWrapper>
    );
  }

  return null;
};

export default NoteReminderAlert;
